import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import CardSucursal from './CardSucursal';
import DetalleReporteSucursal from './DetalleReporteSucursal';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ReporteColaborador() {
    const { loading, setLoading } = useContext(ContextGloball)
    const [regional, setRegional] = useState('');
    const [sucursal, setSucursal] = useState({});
    const [listaSucursal, setListaSucursal] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [ventana, setVentana] = useState(0);
    const [turno,setTurno] = useState('M');
    function verDetalle(dato) {
        console.log(dato);
        setSucursal(dato);
        setVentana(ventana + 1);
    }
    function obtenerInfo(reg) {
        fetch(`${server}/reporte/getPersonalSucursal`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: reg,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setListaSucursal(data.ok);
                }
                setLoading(false);
            })
            .catch(err => console.log(err));
    }
    useEffect(() => {
        setLoading(true);
        if (regional === '') {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            setRegional(info.regional);
            obtenerInfo(info.regional);
        } else {
            obtenerInfo(regional);
        }

    }, [regional, actualizar])
    return (
        <div>
            {ventana === 0 &&
                <div className='container-fluid bg-dark bg-gradient py-1'>
                    <div className='btn-group '>
                        <div className='row row-cols-1 row-cols-md-1 g-1 '>
                            <div className='col d-none'>
                                <div className="input-group input-group-sm my-auto" >
                                    <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Regional</span>
                                    <select className=" form-select text-center" value={regional} onChange={(e) => setRegional(e.target.value)}>
                                        <option value='990'>CBBA</option>
                                        <option value='991'>SCRZ</option>
                                    </select>
                                </div>
                            </div>
                            <div className='col'>
                                <div className="input-group input-group-sm my-auto" >
                                    <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Turno</span>
                                    <select className=" form-select text-center" value={turno} onChange={(e) => {setTurno(e.target.value);setActualizar(!actualizar)}}>
                                        <option value='*'>Todos</option>
                                        <option value='M'>Mañana</option>
                                        <option value='N'>Noche</option>
                                        <option value='O'>Partido</option>
                                        <option value='Q'>Corrido</option>
                                        <option value='X'>Sin Especificar</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <button className='btn btn-sm btn-secondary mx-1' onClick={() => setActualizar(!actualizar)}>
                            <i className="fa-solid fa-rotate-right fa-spin"></i> Actualizar
                        </button>
                    </div>
                </div>}
            {loading === false && ventana === 0 &&
                <div className='container-fluid py-2'>
                    <div className='row row-cols-1 row-cols-md-3 row-cols-lg-4 g-2'>
                        {listaSucursal.map((item, index) => {
                            return (
                                <div className='col col-12 col-md-4 row-lg-3' key={index}>
                                    <div className="card bg-dark bg-gradient" >
                                        <div className='card-header text-light fw-bold m-0 p-0 text-center'>
                                            {`Personal Sucursal ${item.SUCURSAL}`}
                                        </div>
                                        <CardSucursal info={item} tipo={'C'} turno={turno}/>
                                        <div className='card-footer m-0 p-0 text-center'>
                                            <button className='btn btn-secondary btn-sm w-100' onClick={() => verDetalle(item)}>
                                                <i className="fa-solid fa-binoculars"></i> Ver Detalle
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>}
            {ventana !== 0 &&
                <div className=''>
                    <div className='container-fluid m-0 p-0' >
                        <div className='row row-cols-2 g-0 bg-dark bg-gradient'>
                            <div className='col-10 my-auto'>
                                <div className='text-center fw-bold text-light'>
                                    {`Sucursal ${sucursal.SUCURSAL}`}
                                </div>
                            </div>
                            <div className='col-2 text-end'>
                                <button className='btn btn-sm text-danger' onClick={() => setVentana(0)}>
                                    <i className="fa-solid fa-circle-xmark fa-2xl"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <DetalleReporteSucursal info={sucursal} turno={turno} />
                </div>
            }
        </div>
    )
}

export default ReporteColaborador
